"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAAS_SIDEBAR_NODES = void 0;
const constants_1 = require("../constants");
const R = constants_1.AI_CONSOLE_ROLES;
/** 模型服务（MaaS）侧栏节点；在 React 中与「机器学习」并列挂在 `routes.ai` 下。 */
exports.MAAS_SIDEBAR_NODES = [
    {
        id: 'maas-model-square',
        type: 'group',
        menuKey: 'modelMarketGroup',
        msg: 'nav.maas.modelSquareSection',
        roles: R,
        children: [
            {
                id: 'maas-models',
                menuKey: 'modelMarket',
                msg: 'nav.maas.modelSquare',
                path: '/llm/maas/models',
                roles: R,
            },
            {
                id: 'maas-trial',
                menuKey: 'experienceCenter',
                msg: 'nav.maas.experienceCenter',
                path: '/llm/maas/trial',
                roles: R,
            },
        ],
    },
    {
        id: 'maas-service',
        type: 'group',
        menuKey: 'modelServiceGroup',
        msg: 'nav.maas.serviceManage',
        roles: R,
        children: [
            {
                id: 'maas-stats',
                menuKey: 'usageStatistics',
                msg: 'nav.maas.usageStatistics',
                path: '/llm/maas/statistics',
                roles: R,
            },
            {
                id: 'maas-prices',
                menuKey: 'serviceList',
                msg: 'nav.maas.servicePrice',
                path: '/llm/maas/model-service-prices',
                roles: R,
            },
            {
                id: 'maas-apikey',
                menuKey: 'apiKey',
                msg: 'nav.maas.apiKey',
                path: '/llm/maas/apiKey',
                roles: R,
            },
        ],
    },
    {
        id: 'maas-admin',
        type: 'group',
        menuKey: 'modelServiceSettingGroup',
        msg: 'nav.maas.systemSetting',
        visibility: ['adminMode'],
        children: [
            {
                id: 'maas-model-manage',
                menuKey: 'modelServiceSetting',
                msg: 'nav.maas.modelServiceSetting',
                path: '/llm/maas/model-manage',
                adminOnly: true,
            },
        ],
    },
];
